import { render, staticRenderFns } from "./CostProcedure.vue?vue&type=template&id=34edd8ec"
import script from "./CostProcedure.vue?vue&type=script&lang=js"
export * from "./CostProcedure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports